import { render } from "./comparequote.vue?vue&type=template&id=16c4b67e&scoped=true"
import script from "./comparequote.vue?vue&type=script&lang=js"
export * from "./comparequote.vue?vue&type=script&lang=js"

import "./comparequote.vue?vue&type=style&index=0&id=16c4b67e&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-16c4b67e"]])

export default __exports__